import { Link, useNavigate } from "react-router-dom";

export const SideBar = ({
  sidebarOpen,
  setSidebarOpen,
  activeMenu,
  toggleMenu,
  windowWidth,
}) => {
  const navigator = useNavigate();

  const logoutHandler = () => {
    localStorage.removeItem("token");

    navigator("/");
  };
  return (
    <>
      {sidebarOpen && windowWidth < 768 && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark"
          style={{ opacity: 0.5, zIndex: 999 }}
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}

      <nav
        className="text-white p-0 bg-hsts"
        style={{
          width: "250px",
          minHeight: "180vh",
          position: windowWidth < 768 ? "fixed" : "static",
          left: windowWidth < 768 ? (sidebarOpen ? "0" : "-250px") : "auto",
          top: windowWidth < 768 ? "0" : "auto",
          transition: "left 0.3s ease-in-out",
          zIndex: 1000,
          overflowY: "auto",
          display:
            windowWidth >= 768 ? "block" : sidebarOpen ? "block" : "none",
        }}
      >
        <div className="p-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            {sidebarOpen && <h5 className="mb-0">HESTRAS</h5>}
            <button
              className="btn btn-sm btn-outline-light"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              {sidebarOpen ? (
                <i className="fas fa-times"></i>
              ) : (
                <i className="fas fa-bars"></i>
              )}
            </button>
          </div>
        </div>

        {sidebarOpen && (
          <div
            className="p-3 mt-3 overflow-auto"
            style={{ maxHeight: "calc(100vh - 70px)" }}
          >
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to={"/admin"} className="btn btn-dark-2 border-0 w-100 text-start text-white fs-6">
                  <i className="fas fa-home me-2"></i>Dashboard
                </Link>
              </li>
              <li className="mb-2">
                <button
                  className="btn btn-dark-2 border-0 w-100 text-start text-white"
                  onClick={() => toggleMenu("users")}
                >
                  <i className="fas fa-users me-2"></i>Manage users
                  <i
                    className={`fas fa-chevron-down float-end ${
                      activeMenu === "users" ? "rotate" : ""
                    }`}
                  ></i>
                </button>
                {activeMenu === "users" && (
                  <ul className="list-unstyled ms-3 mt-2 py-2">
                    <li className="mb-3">
                      <Link to="/admin/student" className="text-light fs-6 ms-4">
                        {" "}
                        Manage students
                      </Link>
                    </li>
                    <li className="mb-2">
                      <Link to="/admin/coordinator" className="text-light fs-6 ms-4">
                        Manage coordinators
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li className="mb-2">
                <button
                  className="btn btn-dark-2 border-0 w-100 text-start text-white"
                  onClick={() => toggleMenu("settings")}
                >
                  <i className="fas fa-cog me-2"></i>Settings
                  <i
                    className={`fas fa-chevron-down float-end ${
                      activeMenu === "settings" ? "rotate" : ""
                    }`}
                  ></i>
                </button>
                {activeMenu === "settings" && (
                  <ul className="list-unstyled ms-3 mt-2 py-2">
                    <li className="mb-2">
                      <Link to="/admin/password" className="text-light ms-4">Change password</Link>
                    </li>
                  </ul>
                )}
              </li>
              <li className="mb-2">
                <div className="btn btn-dark-2 border-0 w-100 text-start text-danger" onClick={logoutHandler}>
                  <i className="fas fa-sign-out-alt me-2"></i>Sign out
                </div>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </>
  );
};
